var ko = require('knockout');
var $ = require('jquery');

ko.components.register('digital-signing-order-form', {
  viewModel: require('./digital-signing-order-form'),
  template: require('./digital-signing-order-form.template')
});

$('[data-digital-signing-order-form]').each(function() {
  ko.applyBindings({}, this);
});
